import type { KeyValueStorage } from "./KeyValueStorage";

export class BrowserPreferenceStorage implements KeyValueStorage {
	async getItem(key: string): Promise<string | null> {
		return localStorage.getItem(key);
	}

	async getLastModified(key: string): Promise<string | null> {
		return null;
	}

	async setItem(key: string, value: string): Promise<void> {
		localStorage.setItem(key, value);
	}

	async removeItem(key: string): Promise<void> {
		localStorage.removeItem(key);
	}

	async clear(): Promise<void> {
		localStorage.clear();
	}

	async keys(): Promise<string[]> {
		return Object.keys(localStorage);
	}

	isAvailable(): boolean {
		return typeof localStorage !== "undefined";
	}
}
